import { create } from 'zustand';

interface InAppUrlViewState {
  url: string | null;
  setUrl: (url: string) => void;
  clear: () => void;
}

export const useInAppUrlViewStore = create<InAppUrlViewState>((set) => ({
  url: null,
  setUrl: (url) => set({ url }),
  clear: () => set({ url: null }),
}));
